import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FiCheck, FiMicOff } from 'react-icons/fi';

import type { TranscriptStatus } from '../utils/transcript-status';

const STATUS_CONFIG = {
  ready: {
    icon: FiCheck,
    className: 'bg-meeting-50 text-meeting-700',
    labelKey: 'meeting-secretary.meetings.transcript-ready',
    titleKey: 'meeting-secretary.meetings.transcript-ready-hint',
  },
  'not-run': {
    icon: FiMicOff,
    className: 'bg-amber-50 text-amber-800',
    labelKey: 'meeting-secretary.meetings.transcript-not-run',
    titleKey: 'meeting-secretary.meetings.transcript-not-run-hint',
  },
} as const;

export const TranscriptStatusBadge: FC<{ status: TranscriptStatus }> = ({ status }) => {
  const { t } = useTranslation();

  if (!status) return null;

  const { icon: Icon, className, labelKey, titleKey } = STATUS_CONFIG[status];

  return (
    <span
      className={`inline-flex items-center gap-1 text-xs px-2 py-1 rounded-full font-medium whitespace-nowrap ${className}`}
      title={t(titleKey)}
    >
      <Icon size={12} className="flex-shrink-0" />
      {t(labelKey)}
    </span>
  );
};
